import { Directive, ElementRef, Input, OnInit, HostBinding } from '@angular/core';
import { AuthService } from '../auth.service';
import { nullSafe } from 'src/app/utils';

@Directive({
  selector: '[eosHasAccess]'
})
export class HasAccessDirective implements OnInit {

  @Input('eosHasAccess') HasAccess: string | string[];
  @HostBinding('class.disabled') disable = false;

  // roles: string[] = [];
  constructor(private el: ElementRef, private auth: AuthService) { }

  ngOnInit() {
    if (!this.checkAccess()) {
      this.el.nativeElement.style.pointerEvents = 'none';
      this.el.nativeElement.style.cursor = 'default';
      this.disable = true;
      this.el.nativeElement.style.display = 'none';
    }
  }

  checkAccess() {
    return this.auth.isAuthorised(this.HasAccess);
  }
}

